import { Box, Typography } from "@mui/material";

export default function SubscriptionHeader() {
  return (
    <Box textAlign='center' mb={2} sx={{ width: "100%" }}>
      <Typography
        component='h2'
        gutterBottom
        sx={{
          fontSize: {
            xs: "18px",
            lg: "30px",
          },
          fontWeight: 700,
          color: "#303f9f",
        }}
      >
        Choose Your Plan
      </Typography>

      <Typography
        color='text.secondary'
        sx={{
          maxWidth: "800px",
          mx: "auto",
          fontSize: {
            xs: "14px",
            lg: "18px",
          },
        }}
      >
        Explore our plans and pick the one that best suits your legal needs.
      </Typography>
    </Box>
  );
}
